const es = {
  translations: {
    page: {
      login: {
        welcome: "Bienvenido de nuevo",
        username: "Nombre de usuario",
        cpf: "CPF",
        password: "Contraseña",
        rememberme: "Acuérdate de mí",
        forget_password: "¿Has olvidado tu contraseña?",
        dont_account: "¿No tienes una cuenta?",
        login: "Acceso",
        confirm_email: "Confirmar email",
        errors: {
          login: "El login es obligatorio",
          password: "La contraseña debe contener 6 caracteres como mínimo",
        },
      },
      totem_start: {
        environment: "Ambiente",
        code: "Código",
        password: "Contraseña",
        enter: "Entrar",
        version: "Versión",
        developed_by: "Desarrollado por ",
        platform: "Plataforma 4uHub",
        errors: {
          environment: "El ambiente es obligatorio",
          login: "El login es obligatorio",
          password: "La contraseña es obligatoria",
        },
      },
      mainMenu: {
        welcome: "Bienvenido",
        need_help: "Necesitaré ayuda para ser atendido:",
        password_button: "Contraseña fila de espera",
        can_do_it: "Puedo hacer mi servicio solo:",
        check_in_button: "Check-In",
        schedule_button: "Programación de consultas y exámenes",
        totem: "Totem de Servicio",
        thanks: "¡Gracias por usar nuestro servicio!",
      },
      loginTemporary: {
        welcome: "Bienvenido(a)",
        login: "Login",
        password: "Contraseña",
        dont_account: "¿No tienes una cuenta?",
        access_button: "Acceso",
        access_exam: "Acceso a exámenes",
        errors: {
          login: "El login es obligatorio",
          password: "La contraseña es obligatoria",
        },
      },
      not_found: {
        page_not_found: "¡Uy! ",
        server_not_responding: "Servidor no responde",
        try_again: "Intentar otra vez",
        back_to_begin: "De vuelta a casa",
        back_to_login: "Atrás para iniciar sesión",
        something_went_wrong: "Algo salió mal",
      },
      documents: {
        title: "Términos y políticas",
        subtitle: "Estos son los documentos que aceptó",
        no_docs:
          "Todavía no ha aceptado ningún documento. Después de aceptar cualquier documento, aparecerá aquí",
      },

      register: {
        register: "Registro",
        document: "Documento",
        has_register: "¿Ya registrado? ",
        birth_date: "Fecha de nacimiento",
        email: "Correo electrónico",
        confirm_email: "Confirmar correo electrónico",
        password: "Contraseña",
        confirm_password: "Confirmar Contraseña",
        notification: "Registrado correctamente",
        errors: {
          document: "El documento es obligatorio.",
          password: "La contraseña es obligatoria",
          email: "El correo electrónico es obligatorio",
          confirm_email: "Los correos electrónicos deben coincidir",
          confirm_password: "Las contraseñas deben coincidir",
          birth_date: "La fecha de nacimiento es obligatoria.",
        },
        emailSendMessage:
          "Le enviamos un correo electrónico para confirmar la creación de la cuenta. Compruebe la pestaña de correo no deseado :)",
        backToLogin: "Volver al inicio de sesión",
        individuals: {
          contacts: "Contactos",
          contact_type: "Tipo de contacto",
          add_contact: "Añadir contacto",
          addresses: "Direcciones",
          add_address: "Añaadir dirección",
        },
      },
      changePassword: {
        change_password: "Cambiar la contraseña",
        actual_password: "Contraseña real",
        new_password: "Nueva contraseña",
        save: "Ahorrar",
        confirm_new_password: "Confirmar nueva contraseña",
        success_message: "Contraseña cambiada con éxito",
        errors: {
          actual_password: "La contraseña actual es obligatoria",
          new_password: "La nueva contraseña es obligatoria",
          confirm_new_password: "La contraseña de confirmación es obligatoria",
          passwords_match: "Las contraseñas no coinciden",
        },
      },
      confirm_email: {
        confirm_email: "Confirmar correo electrónico",
        confirming: "Confirmando",
        resent: "Correo electrónico reenviado con éxito",
        success: {
          title: "Correo electrónico confirmado",
          description:
            "Su correo electrónico ha sido confirmado con éxito, vuelva al inicio de sesión para acceder a su cuenta",
        },
        subtitle:
          'Ingrese el código recibido por correo electrónico a continuación y luego haga clic en "Confirmar email".',
        username: "Nombre de usuario",
        document: "CPF",
        code: "Código",
        error: {
          title: "Hubo un error",
          description:
            "Ocurrió un error al confirmar el correo electrónico, intente nuevamente",
          action: "Redirigir correo",
          username: "El {{username}} es obligatorio",
          code: "El Código es obligatorio",
        },
      },
      noAccess: {
        message:
          "¡Ups! ¡Parece que no tienes permiso para acceder a esta página!",
        button: "volver arriba",
      },
    },
    components: {
      backButton: "Atrás",
      private: {
        permission: "¡Uy! ",
      },
      themeSwitch: {
        change_theme: "Cambiar de tema",
      },
      languageSwitch: {
        change_language: "Cambiar idioma",
      },
      no_data: "No hay datos para mostrar",
      establishments: {
        select: "Seleccione un establecimiento",
        change: "Cambiar establecimiento",
      },
      changeLanguageForm: {
        title: "Cambiar idioma",
        language: "Idioma",
        button: "Cambiar",
      },
      autocomplete: {
        noOptions: "Sin opciones",
        hint: "Escriba al menos 3 caracteres para buscar",
      },
      avatarDropdown: {
        tooltip_user: "Configuraciones de la cuenta",
        tooltip_visit: "Acceso",
      },
      forgetPasswordForm: {
        title: "Esqueceu a senha?",
        subtitle:
          "Ingrese su CPF a continuación y le enviaremos un código a su correo electrónico para restablecer su contraseña.",
        button: "Enviar",
        login: "CPF",
        login_required: "¡Correo electronico es requerido!",
        notification_email_sent: "Correo electrónico enviado con éxito!",
        back_login: "Atrás para iniciar sesión",
        notification_email_confirmed:
          "Correo electrónico confirmado exitosamente, ingrese nuevamente sus datos de acceso.",
      },
      resetPasswordForm: {
        title: "Nueva contraseña",
        subtitle:
          "Ingresa el código enviado a tu correo electrónico. Si no lo encuentras, revisa tu área de spam.",
        password: "Contraseña",
        confirm_password: "Confirmar Contraseña",
        confirmation_code: "Código de confirmación",
        new_password_required: "Se requiere contraseña.",
        confirm_new_password_required: "Se requiere confirmar la contraseña.",
        passwords_match: "Las contraseñas no coinciden.",
        confirmation_code_required: "El código de confirmación es obligatorio",
        notification_password_success: "¡Contraseña cambiada con éxito!",
        counter:
          "Reenviar correo electrónico disponible en {{counter}} segundo(s)",
      },
      resendEmail: {
        title: "Parece que aún no ha confirmado su correo electrónico.",
        description:
          "Haga clic en el botón de abajo para reenviar el correo electrónico de confirmación.",
        button: "Reenviar email",
        success: "Correo electrónico enviado con éxito!",
      },

      registeredModal: {
        title: "¡Registro completado exitosamente!",
        description:
          "Haga clic en el botón a continuación y luego siga los pasos para confirmar su email.",
        button: "Ok",
      },
      emailResent: {
        title: "E-mail reenviado com sucesso!",
        description:
          "Reenviamos el código al email registrado, revisamos su correo electrónico, copiamos el código de confirmación, hacemos clic en el botón a continuación y seguimos los pasos para confirmar su email.",
        button: "Ok",
      },
      registerError: {
        button: "Ok",
      },
      noRowsMessage: {
        no_permission: "No tienes permiso para acceder a esta información",
        no_data: "No hay datos para mostrar",
      },

      accessTemporaryMessage: {
        access_temporary: "Acceso temporal",
        register:
          "Regístrese para acceder a todos los recursos de nuestro portal",
        login:
          "Inicie sesión para acceder a todos los recursos de nuestro portal",
        register_btn: "Registro",
        login_btn: "Acceso",
      },
      accessPortalBtn: {
        button: "Acceso al portal",
      },
    },
    logout: "Cerrar sesión",
    change_password: "Cambiar la contraseña",
    change_language: "Cambiar idioma",
    access_denied: "Necesita estar registrado para acceder a esta página",
  },
};

export default es;
